import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

export const RoundedWrapperStyled = styled.div<{ $minHeight?: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 4rem 10rem 8rem;
  min-height: ${({ $minHeight }): CSSProp => $minHeight || '38rem'};
`;
